import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ContainerComponent, ContainerSize } from '@freelancer/ui/container';
import { LayoutMinHeight, LayoutType } from './page-layout.types';

@Component({
  standalone: true,
  imports: [ContainerComponent],
  selector: 'fl-page-layout',
  template: `
    <fl-container
      [mobilePadding]="mobilePadding"
      [padding]="innerPadding ?? padding"
      [size]="pageSize"
    >
      @if (
        layoutType === LayoutType.SPLIT ||
        layoutType === LayoutType.SPLIT_EXTEND
      ) {
        <div
          class="Split"
          [class.Extended]="layoutType === LayoutType.SPLIT_EXTEND"
        >
          <ng-content select="fl-page-layout-primary"></ng-content>
          <ng-content select="fl-page-layout-secondary"></ng-content>
        </div>
      }

      @if (layoutType === LayoutType.SINGLE) {
        <ng-content select="fl-page-layout-single"></ng-content>
      }
    </fl-container>
  `,
  styleUrls: ['./page-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLayoutComponent {
  LayoutType = LayoutType;

  @Input() layoutType = LayoutType.SINGLE;

  @HostBinding('attr.data-minheight')
  @Input()
  layoutMinHeight = LayoutMinHeight.FULL;

  @HostBinding('attr.data-minheight-desktop-small')
  @Input()
  layoutMinHeightDesktopSmall?: LayoutMinHeight;

  @Input() pageSize = ContainerSize.DESKTOP_LARGE;

  @Input()
  @HostBinding('attr.data-padding')
  padding = true;

  /** Sets the padding for the inner container (left/right padding). Will default to the `padding` value if not given. */
  @Input()
  innerPadding?: boolean;

  /** Sets the mobile padding property for the inner container. */
  @Input()
  mobilePadding = false;
}
